import "../k";

export const QUIZ_GREEN = Color.fromHex("4DEFCD");
export const QUIZ_PINK = Color.fromHex("EF51C2");